import React from 'react';
import {getPrice} from "../util/price";

class SummaryItem extends React.Component {
    renderExtras() {
        if (!this.props.item.extras) {
            return null;
        } else {
            return this.props.item.extras.map(function(item, index) {
                return (
                    <div key={index} className="flex booking-form__extra-item">
                        <div className="flex-1">+ {item.title}</div>
                        <div key={index}>{trans.currency_prepend} {getPrice(item.price)}{trans.currency_append}</div>
                    </div>
                );
            });
        }
    }

    render() {
        const price = this.props.item.isOnSale ? parseFloat(this.props.item.salesPrice.value) : parseFloat(this.props.item.price.value);
        return (
            <div className="booking-form__summary-item">
                <div className="flex">
                    <div className="flex-1">{this.props.item.title}</div>
                    <ul>
                        <li>x{this.props.item.count}</li>
                        {!isNaN(price) ? <li>{trans.currency_prepend}{price}{trans.currency_append}</li> : <li />}
                    </ul>
                </div>
                { this.renderExtras() }
            </div>
        )
    }
}

export default SummaryItem;



// WEBPACK FOOTER //
// ./scripts/components/SummaryItem.jsx